import { Injectable } from '@angular/core';
import { CryptoService } from './crypto.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CryptoListResolverService {

  constructor(
    private cryptoService: CryptoService
  ) { }

  resolve(): Observable<any> {
    return this.cryptoService.getCurrencies();
  }
}
